module.exports = __webpack_public_path__ + "static/img/son1.c27262b5.png";